<div class="page-container">
    <h1 class="page-title">
        <mat-icon class="title-icon">source</mat-icon>
        {{ "title.project-detail" | translate }}
    </h1>

    <app-spinner *ngIf="loading" fill></app-spinner>

    <div *ngIf="!loading" class="content">
        <form class="project-form">
            <!-- Champs principaux -->
            <div class="section">
                <mat-form-field appearance="outline">
                    <mat-icon matPrefix>title</mat-icon>
                    <mat-label>{{'form.name'|translate}}</mat-label>
                    <input matInput [ngModel]="project().name" (ngModelChange)="patchProject({name: $event})"
                        name="name" required>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-icon matPrefix>description</mat-icon>
                    <mat-label>{{'form.description'|translate}}</mat-label>
                    <textarea matInput [ngModel]="project().description"
                        (ngModelChange)="patchProject({description: $event})" name="description" rows="3"></textarea>
                </mat-form-field>

                <div class="form-row full-width">
                    <mat-form-field appearance="outline">
                        <mat-icon matPrefix>business_center</mat-icon>
                        <mat-label>{{ 'settings.project.modality' | translate }}</mat-label>
                        <mat-select [ngModel]="project().modality" (ngModelChange)="patchProject({modality: $event})"
                            name="modality" required>
                            <mat-option value="location">
                                <mat-icon>location_city</mat-icon>
                                <span>Location</span>
                            </mat-option>
                            <mat-option value="sale">
                                <mat-icon>sell</mat-icon>
                                <span>{{'settings.project.sale'|translate}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!--<mat-form-field appearance="outline">
                        <mat-icon matPrefix>category</mat-icon>
                        <mat-label>{{ 'settings.project.type' | translate }}</mat-label>
                        <mat-select [(ngModel)]="projectType" name="type" required (selectionChange)="onTypeChanged($event)" [disabled]="selectedServices?.length > 0">
                          <mat-option *ngFor="let type of types" [value]="type">{{('settings.project.' + type)|translate}}</mat-option>
                        </mat-select>
                    </mat-form-field>-->
                </div>

                <div class="time-selector">
                    <mat-icon>event</mat-icon>

                    <label>{{'events.time'|translate}}</label>

                    <app-range-picker [startDate]="project().startDate" [endDate]="project().endDate"
                        [min]="project().startDate" [max]="'5 years'" (change)="onPickerChanged($event)">
                    </app-range-picker>
                </div>

                <div class="services">
                    <h3>
                        <mat-icon>assignment</mat-icon>
                        {{'settings.project.services' | translate}}
                    </h3>

                    <div class="service-options">
                        <div class="service-option" *ngFor="let service of availableServices"
                            [class.selected]="isSelected(service.value)" [style.--service-color]="service.color"
                            (click)="toggleService(service.value)">
                            <div class="service-badge">
                                <mat-icon [style.color]="isSelected(service.value) ? 'white' : service.color">{{
                                    service.icon }}</mat-icon>
                            </div>

                            <span>{{ service.label }}</span>

                            <mat-icon *ngIf="!isSelected(service.value)" class="check-icon"
                                fontIcon="radio_button_unchecked">
                            </mat-icon>

                            <mat-icon *ngIf="isSelected(service.value)" class="check-icon" [style.color]="service.color"
                                fontIcon="check_circle">
                            </mat-icon>
                        </div>
                    </div>

                    <!-- Quantités d'unités -->
                    <div class="unit-quantities" *ngIf="mergedUnitGroups.length > 0" @slideDown>
                        <h4>
                            <mat-icon>devices_other</mat-icon>
                            {{ 'services.unit_quantities' | translate }}
                        </h4>

                        <div class="unit-quantity-grid">
                            <div class="unit-quantity-row" *ngFor="let group of mergedUnitGroups">
                                <div class="unit-quantity-info">
                                    <span class="unit-quantity-key">{{ group.key }}</span>
                                    <span class="unit-quantity-sub" *ngIf="group.units.length > 1">{{ group.units.join('
                                        · ') }}</span>
                                </div>
                                <mat-form-field appearance="outline" class="quantity-field">
                                    <input matInput type="number" [(ngModel)]="unitQuantities[group.key]"
                                        [name]="'qty-' + group.key" min="0" max="99" />
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <mat-checkbox [ngModel]="project().addDemoData"
                        (ngModelChange)="patchProject({addDemoData: $event})" name="addDemoData" class="demo-data">
                        {{ 'projects.services.add_demo_data' | translate }}
                    </mat-checkbox>
                </div>
            </div>

            <!-- Champs avancés -->
            <div *ngIf="formType" [@fadeInOut] class="section advanced-section">
                <h3>
                    <mat-icon>settings</mat-icon>
                    {{'form.advanced'|translate}}
                </h3>

                <mat-form-field appearance="outline">
                    <mat-icon matPrefix>tag</mat-icon>
                    <mat-label>{{ 'settings.project.reference' | translate }}</mat-label>
                    <input matInput [ngModel]="project().reference" (ngModelChange)="patchProject({reference: $event})"
                        name="reference">
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-icon matPrefix>location_city</mat-icon>
                    <mat-label>{{ 'settings.project.city' | translate }}</mat-label>
                    <input matInput [ngModel]="project().city" (ngModelChange)="patchProject({city: $event})"
                        name="city">
                </mat-form-field>

                <div class="form-row">
                    <mat-form-field appearance="outline">
                        <mat-icon matPrefix>east</mat-icon>
                        <mat-label>Longitude</mat-label>
                        <input matInput [ngModel]="project().lon" (ngModelChange)="patchProject({lon: $event})"
                            name="lon" step="0.00001" type="number">
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-icon matPrefix>north</mat-icon>
                        <mat-label>Latitude</mat-label>
                        <input matInput [ngModel]="project().lat" (ngModelChange)="patchProject({lat: $event})"
                            name="lat" step="0.00001" type="number">
                    </mat-form-field>
                </div>

                <mat-form-field appearance="outline">
                    <mat-icon matPrefix>schedule</mat-icon>
                    <mat-label>{{ 'settings.project.timezone' | translate }}</mat-label>
                    <mat-select [ngModel]="project().timezone" (ngModelChange)="patchProject({timezone: $event})"
                        name="timezone">
                        <mat-option *ngFor="let timezone of timezones" [value]="timezone">
                            {{ timezone }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <div class="form-row">
                    <mat-form-field appearance="outline">
                        <mat-icon matPrefix>timer</mat-icon>
                        <mat-label>{{ 'units.device.offline_delai' | translate }} (seconds)</mat-label>
                        <input matInput [ngModel]="project().offlineDelay"
                            (ngModelChange)="patchProject({offlineDelay: $event})" name="offlineDelay" step="1"
                            type="number">
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-icon matPrefix>router</mat-icon>
                        <mat-label>Port NTRIP</mat-label>
                        <input matInput [ngModel]="project().portNtrip"
                            (ngModelChange)="patchProject({portNtrip: $event})" name="portNtrip">
                    </mat-form-field>
                </div>

                <mat-form-field appearance="outline">
                    <mat-icon matPrefix>home</mat-icon>
                    <mat-label>{{ 'settings.project.starting_page' | translate }}</mat-label>
                    <mat-select [ngModel]="project().startingPage"
                        (ngModelChange)="patchProject({startingPage: $event})" name="startingPage">
                        <mat-option value="home">Home</mat-option>
                        <mat-option value="viewer">Viewer</mat-option>
                        <mat-option value="devices">Devices</mat-option>
                    </mat-select>
                </mat-form-field>

                <!-- Planning -->
                <div class="schedule-section">
                    <h4>
                        <mat-icon>schedule</mat-icon>
                        {{ 'units.schedule' | translate }}
                    </h4>
                    <app-schedule [schedule]="schedule" (scheduleChange)="onScheduleChange($event)"></app-schedule>
                </div>
            </div>
        </form>

        <!-- Actions -->
        <div class="actions">
            <div class="toggle-container">
                <mat-slide-toggle (change)="toggleForm($event.checked)"></mat-slide-toggle>
                <span>{{ formType ? ('form.advanced'|translate) : 'Simple' }}</span>
            </div>

            <div class="buttons">
                <lib-button color="outline" icon="cancel" (click)="cancel()"
                    text="{{'form.cancel'|translate}}"></lib-button>
                <lib-button color="primary" icon="save" (click)="saveProject()"
                    text="{{'form.save'|translate}}"></lib-button>
            </div>
        </div>
    </div>
</div>